module.exports = {"130729001":"孔家庄街道","130729100":"孔家庄镇","130729101":"万全镇","130729102":"洗马林镇","130729103":"郭磊庄镇","130729200":"膳房堡乡","130729201":"北新屯乡","130729202":"宣平堡乡","130729203":"高庙堡乡","130729204":"旧堡乡","130729205":"安家堡乡","130729206":"北沙城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130729.json
// module id = 279
// module chunks = 0